export default "__VITE_ASSET__e0b3fef6__"